const NUMERIC_ARRAY_FIELDS = ['income_sources', 'expenses', 'assets', 'liabilities', 'insurance_policies'];

function sanitizeValue(value) {
  if (value === '') return null;
  if (typeof value === 'string' && value.trim() !== '' && !isNaN(value)) {
    return Number(value);
  }
  if (Array.isArray(value)) {
    return value.map(sanitizeValue);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, sanitizeValue(v)])
    );
  }
  return value;
}

export function sanitizeNumericFields(data = {}) {
  const result = { ...data };
  for (const field of NUMERIC_ARRAY_FIELDS) {
    if (Array.isArray(result[field])) {
      result[field] = sanitizeValue(result[field]);
    }
  }
  return result;
}
